
namespace Gordic.Adm.WebControls {

    /**
     * Externí identifikace
     * 
     * @author thazmuka
     * @since 484.1.0.0
     */
    export class AdmExtIdentifikace {

        private panelElement: JQuery<HTMLElement>;
        private sxs: string;
        private typ_obj: number;
        private grid: JQuery<HTMLElement>;
        private server: GContent;

        /**
         * vytvořit panel auditu přístupu (historie změn)
         * @param a_sxs
         * @param a_typ_obj
         * @param sidebarElement
         */
        public create(a_sxs: string, a_typ_obj: number , sidebarElement?: JQuery<HTMLElement>): GSideBarPanelOptions {
            this.sxs = a_sxs;
            this.typ_obj = a_typ_obj;

            if (sidebarElement == null) {
                this.panelElement = $("<div>");
            }
            else {
                this.panelElement = sidebarElement;
            }

            this.getGridExtSub();

            return {
                customDiv: this.panelElement,
                id: "idExtId",
                leaf: { caption: "jres:32000147" },                              //RC 32000147 : Ext.ID
                icon: "gi-nahled",
                caption: "jres:32000148",                                       //RC 32000148 : Externí identifikace
                open: (ev, obj) => {
                    //this.panelElement = $(ev.target);
                    //this.panelElement.empty();
                    //this.getGridExtSub();
                }
            }
        }

        private createGrid(format) {
            this.grid = $("<div>").appendTo(this.panelElement).gautofit({ parentElement: ".g-sbp-content" }).ggrid({
                columns: format,
                columnMode: "full",
                multi: false,
            });
        }

        //FCE PRO VYKRESLENÍ SEZNAM auditních dat obecného subjektu administrace
        private getGridExtSub() {
            if (this.server === undefined) {
                this.server = new GContent("Gordic.Adm.WebControls.AdmSidebarsService", this.panelElement);
            }

            // Načtení seznamu změn zadaného objektu ( zadán podle svého ID a typu )
            Gordic.Isl.ExterniIdentifikace.listWithMeta({
                filters: { sxs: this.sxs, typ_obj: this.typ_obj },
                fragments: []
            })
                .get()
                .done((response) => {
                    var obj = GAdmUtils.createGridFromResponseWithMeta(response);
                    this.createGrid(obj.format);
                    this.grid.ggrid("setData", obj.view, true);
                });

            //this.server.call("GetSeznamIntddav", { a_sxs: this.sxs, a_type: this.typ_obj })
            //    .then((data) => {
            //        var obj = GAdmUtils.createGrid(data);
            //        this.createGrid(obj.format);
            //        this.grid.ggrid("setData", obj.view, true);
            //    });
        }



    }

}

